import { lazy, Suspense } from "react";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import SEOHead from "@/components/SEOHead";

const Platforms = lazy(() => import("@/components/Platforms"));
const Features = lazy(() => import("@/components/Features"));
const Pricing = lazy(() => import("@/components/Pricing"));
const Contact = lazy(() => import("@/components/Contact"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => {
  return (
    <>
      <SEOHead 
        title="Valmira - Premium Agency Ad Accounts | Scale Your Campaigns"
        description="Get instant access to premium agency ad accounts for Meta, TikTok, Snapchat, Pinterest and 40+ platforms. Unlimited spend, compliance guaranteed, 24/7 support."
        keywords="agency ad accounts, Meta ads, TikTok ads, Snapchat ads, Pinterest ads, digital marketing, advertising agency, ad account access, unlimited ad spend"
        canonicalUrl="https://valmira-agency.com"
      />
      <div className="min-h-screen overflow-x-hidden w-full">
        <Navigation />
        <main>
          <Hero />
          <Suspense fallback={null}>
            <section id="platforms" aria-label="Available advertising platforms">
              <Platforms />
            </section>
            <section id="features" aria-label="Features and benefits">
              <Features />
            </section>
            <section id="pricing" aria-label="Pricing plans">
              <Pricing />
            </section>
            <section id="contact" aria-label="Contact and information request">
              <Contact />
            </section>
          </Suspense>
        </main>
        <Suspense fallback={null}>
          <Footer />
        </Suspense>
      </div>
    </>
  );
};

export default Index;